import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Fab, Grid, Theme, useMediaQuery } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { PermissionArea } from '@pbt/pbt-ui-components'

import DialogNames from '~/constants/DialogNames'
import { getCRUDByArea } from '~/store/reducers/auth'
import { addSearch } from '~/utils'
import useDialog from '~/utils/useDialog'

import SpaceDetails from './SpaceDetails'
import SpacesTableComponent from './SpacesTableComponent'

const useStyles = makeStyles(
  () => ({
    button: {
      minWidth: 135,
      height: 40,
    },
  }),
  { name: 'SpacesPage' },
)

const SpacesPage = () => {
  const navigate = useNavigate()
  const { spaceId } = useParams()
  const location = useLocation()
  const classes = useStyles()
  const permissions = useSelector(getCRUDByArea(PermissionArea.SPACE))
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'))
  const { t } = useTranslation('Admin')

  const [openSpaceDialog] = useDialog(DialogNames.SPACE)

  const onDetailsClose = () => {
    navigate(addSearch(location, '/admin/general/spaces'))
  }

  if (isMobile && typeof spaceId !== 'undefined') {
    return <SpaceDetails itemId={spaceId} onClose={onDetailsClose} />
  }

  const headerButtons = (
    <Grid container item justifyContent="flex-end" px={3} py={2}>
      <Fab
        className={classes.button}
        color="inherit"
        variant="extended"
        onClick={() => openSpaceDialog()}
      >
        {t('Admin:SPACE.NEW_SPACE')}
      </Fab>
    </Grid>
  )

  return (
    <Grid container item flex={1} wrap="nowrap">
      <SpacesTableComponent
        headerButtons={permissions.create && headerButtons}
        spaceId={spaceId}
        onDetailsClose={onDetailsClose}
      />
    </Grid>
  )
}

export default SpacesPage
